import React, { forwardRef } from "react";

import { DisplayHoursProps } from "./types";
import { formatHours, formatNumber } from "../../utils";
import { Tooltip } from "../Tooltip";
import { Typography } from "../Typography/Typography";

export const DisplayHours = forwardRef<HTMLSpanElement, DisplayHoursProps>(
  (
    {
      value,
      variant = "Body 2",
      thousandSeparator = ",",
      decimalSeparator = ".",
      trimZeroMinutes = false,
      trimDecimals = true,
      decimalSpaces = 2,
      format = "long",
      disableTooltip = false,
      className,
      withLeadingZero,
      as = "span",
      ...rest
    },
    ref
  ) => {
    const shouldDisplayShort = format === "short" && value >= 1000;

    const longValue = formatHours(
      value,
      withLeadingZero,
      trimZeroMinutes,
      "long"
    );
    const shortValue = formatNumber(
      value,
      thousandSeparator,
      decimalSeparator,
      trimDecimals,
      decimalSpaces,
      "short"
    );

    if (shouldDisplayShort) {
      return (
        <Tooltip title={formatHours(value)} disable={disableTooltip}>
          <Typography
            as={as}
            variant={variant}
            className={className}
            ref={ref}
            {...rest}
          >
            {shortValue}
          </Typography>
        </Tooltip>
      );
    }

    return (
      <Typography
        as={as}
        variant={variant}
        className={className}
        ref={ref}
        {...rest}
      >
        {longValue}
      </Typography>
    );
  }
);

DisplayHours.displayName = "DisplayHours";
